'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bignumber = require('bignumber.js');

var _safeToBn = require('../../utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

var _tokenUtilities = require('../../utilities/tokenUtilities');

var _PropTypeBn = require('../../utilities/PropTypeBn');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthorizeTokenNoInputs = function (_React$PureComponent) {
  _inherits(AuthorizeTokenNoInputs, _React$PureComponent);

  function AuthorizeTokenNoInputs(props) {
    _classCallCheck(this, AuthorizeTokenNoInputs);

    var _this = _possibleConstructorReturn(this, (AuthorizeTokenNoInputs.__proto__ || Object.getPrototypeOf(AuthorizeTokenNoInputs)).call(this, props));

    _this.state = {
      authorizationAmount: props.amount.toString()
    };

    _this.handleAmountChange = _this.handleAmountChange.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(AuthorizeTokenNoInputs, [{
    key: 'handleAmountChange',
    value: function handleAmountChange(_ref) {
      var value = _ref.target.value;

      this.setState({ authorizationAmount: value });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      return this.props.close((0, _safeToBn2.default)(this.state.authorizationAmount));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          close = _props.close,
          tokenSymbol = _props.tokenSymbol,
          amount = _props.amount,
          tokenDecimals = _props.tokenDecimals,
          appName = _props.appName,
          forPayment = _props.forPayment,
          customMessage = _props.customMessage;


      var transactionAmountFormatted = (0, _tokenUtilities.formatTokenWei)(amount, tokenDecimals, tokenSymbol);
      var allTransactionsTokenWei = (0, _tokenUtilities.convertFromTokenWei)(_constants.MAX_TOKEN_AUTHORIZATION_AMOUNT_WEI, tokenDecimals);

      var defaultMessage = _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'p',
          null,
          'This transaction will authorize our smart contract to transfer ',
          !forPayment && 'up to ',
          _react2.default.createElement(
            'strong',
            null,
            transactionAmountFormatted
          ),
          ' from your wallet.'
        ),
        !forPayment && _react2.default.createElement(
          'p',
          { className: 'note' },
          _react2.default.createElement(
            'strong',
            null,
            'Note:'
          ),
          ' If you want to use ',
          tokenSymbol,
          ' again, you will have to repeat this step each time you use ',
          appName,
          ' in the future.'
        )
      );

      var thisTransactionMessage = customMessage || defaultMessage;

      var allTransactionsMessage = _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'p',
          null,
          'This transaction will authorize our smart contract to transfer up to',
          ' ',
          _react2.default.createElement(
            'strong',
            null,
            (0, _bignumber.BigNumber)(allTransactionsTokenWei).toExponential(3),
            ' ',
            tokenSymbol
          ),
          ' ',
          'from your wallet.'
        ),
        _react2.default.createElement(
          'p',
          { className: 'note' },
          _react2.default.createElement(
            'strong',
            null,
            'Note:'
          ),
          ' The authorization amount is a formula that represents an unlimited amount of tokens. This will prevent you from having to authorize the transfer of',
          ' ',
          tokenSymbol,
          ' for future ',
          forPayment ? 'payments' : appName + ' interactions',
          ' \u2014 saving time and gas fees.'
        )
      );

      var switchToAllTransactions = _react2.default.createElement(
        'p',
        { className: 'switch-auth-type' },
        'Do you plan on ',
        forPayment ? 'paying with CAT' : 'using ' + tokenSymbol + ' again',
        ' in the future?',
        _react2.default.createElement('br', null),
        'Click',
        ' ',
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            value: _constants.MAX_TOKEN_AUTHORIZATION_AMOUNT_WEI.toString(),
            onClick: this.handleAmountChange
          },
          'here'
        ),
        ' ',
        'to save time and gas fees.'
      );

      var switchToThisTransaction = _react2.default.createElement(
        'p',
        { className: 'switch-auth-type' },
        'Don\'t plan on ',
        forPayment ? 'paying with CAT' : 'using ' + tokenSymbol + ' again',
        ' in the future?',
        _react2.default.createElement('br', null),
        'Click',
        ' ',
        _react2.default.createElement(
          'button',
          { type: 'button', value: amount.toString(), onClick: this.handleAmountChange },
          'here'
        ),
        ' ',
        'to authorize only ',
        _react2.default.createElement(
          'strong',
          null,
          transactionAmountFormatted
        ),
        '.'
      );

      var usingTransactionAmount = this.state.authorizationAmount === amount.toString();

      var switchAmountMessage = usingTransactionAmount ? switchToAllTransactions : switchToThisTransaction;

      var transactionMessage = _react2.default.createElement(
        'div',
        { className: 'transaction-message' },
        usingTransactionAmount ? thisTransactionMessage : allTransactionsMessage
      );

      return _react2.default.createElement(
        'div',
        { className: 'authorize-token no-inputs' },
        _react2.default.createElement(
          'h2',
          null,
          'Authorize ',
          forPayment ? 'Fee Payment' : 'Token Transfer'
        ),
        _react2.default.createElement(
          'div',
          null,
          transactionMessage
        ),
        _react2.default.createElement(
          'div',
          { className: 'actions' },
          _react2.default.createElement(
            'button',
            { type: 'button', name: 'back', className: 'btn cancel', onClick: function onClick() {
                return close(null);
              } },
            'Back'
          ),
          _react2.default.createElement(
            'button',
            { type: 'button', name: 'continue', className: 'btn', onClick: this.handleClick },
            'Authorize'
          )
        ),
        switchAmountMessage
      );
    }
  }]);

  return AuthorizeTokenNoInputs;
}(_react2.default.PureComponent);

AuthorizeTokenNoInputs.displayName = 'AuthorizeTokenNoInputs';

AuthorizeTokenNoInputs.defaultProps = {
  appName: 'Tabby',
  forPayment: false,
  customMessage: null
};

_PropTypeBn.PropTypeBn.isRequired = _PropTypeBn.PropTypeBnIsRequired;
AuthorizeTokenNoInputs.propTypes = {
  amount: _PropTypeBn.PropTypeBn.isRequired,
  tokenSymbol: _propTypes2.default.string.isRequired,
  tokenDecimals: _propTypes2.default.number.isRequired,
  close: _propTypes2.default.func.isRequired,
  appName: _propTypes2.default.string,
  forPayment: _propTypes2.default.bool,
  customMessage: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = AuthorizeTokenNoInputs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/modals/AuthorizeTokenNoInputs.js
// module id = 1228
// module chunks = 0